// extracted by mini-css-extract-plugin
module.exports = {"Social":"Social_Social__3uLC3","Icon":"Social_Icon__1ASOj","IconRed":"Social_IconRed__j9Hsd","IconGold":"Social_IconGold__2GOR3"};